const createAndSendPaymentForm = (request) => {
  const form = document.createElement('form');
  form.setAttribute('id', request?.id);
  form.setAttribute('method', 'POST');
  form.setAttribute('action', request?.action);
  form.setAttribute('data-testid', request?.id);
  form.setAttribute('style', 'display: none');

  Object.keys(request?.map).forEach((key) => {
    const input = document.createElement('input');
    input.setAttribute('name', key);
    input.setAttribute('value', request?.map[key]);
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
  return form;
};

export default createAndSendPaymentForm;
